import { CalculationType } from '@qover-private/protos-web/qover/dojo/pricing/v1/pricing';

export enum Variant {
  VARIANT_UNSPECIFIED = 'VARIANT_UNSPECIFIED',
  VARIANT_ASSISTANCE = 'VARIANT_ASSISTANCE',
  VARIANT_THEFT = 'VARIANT_THEFT',
  VARIANT_THEFT_ASSISTANCE = 'VARIANT_THEFT_ASSISTANCE',
  VARIANT_THEFT_DAMAGE = 'VARIANT_THEFT_DAMAGE',
  VARIANT_THEFT_DAMAGE_ASSISTANCE = 'VARIANT_THEFT_DAMAGE_ASSISTANCE',
}

export enum DamageDeductible {
  DAMAGE_DEDUCTIBLE_UNSPECIFIED = 'DAMAGE_DEDUCTIBLE_UNSPECIFIED',
  DAMAGE_DEDUCTIBLE_ENGLISH_10PC = 'DAMAGE_DEDUCTIBLE_ENGLISH_10PC',
  DAMAGE_DEDUCTIBLE_ENGLISH_75_FIX = 'DAMAGE_DEDUCTIBLE_ENGLISH_75_FIX',
  DAMAGE_DEDUCTIBLE_STANDARD_10PC = 'DAMAGE_DEDUCTIBLE_STANDARD_10PC',
  DAMAGE_DEDUCTIBLE_STANDARD_35_FIX = 'DAMAGE_DEDUCTIBLE_STANDARD_35_FIX',
}

export enum TheftDeductible {
  THEFT_DEDUCTIBLE_UNSPECIFIED = 'THEFT_DEDUCTIBLE_UNSPECIFIED',
  THEFT_DEDUCTIBLE_STANDARD_10PC = 'THEFT_DEDUCTIBLE_STANDARD_10PC',
  THEFT_DEDUCTIBLE_NO_DEDUCTIBLE = 'THEFT_DEDUCTIBLE_NO_DEDUCTIBLE',
}

export interface DiscountCode {
  name?: string;
  isRecurring?: boolean;
  canBeCumulated?: boolean;
  value?: number;
  calculationType?: CalculationType;
  discountId?: string;
}

export interface UwQuestions {
  question1?: boolean;
  question2?: boolean;
  question3?: boolean;
}

export interface TermsProps {
  variant?: Variant;
  dataShareConsent?: boolean;
  discountCodes?: DiscountCode[];
  depreciation?: boolean;
  damageDeductible?: DamageDeductible;
  theftDeductible?: TheftDeductible;
  uwQuestions?: UwQuestions;
  offeredForFree?: boolean;
}

export class Terms {
  variant?: Variant;
  dataShareConsent?: boolean;
  discountCodes?: DiscountCode[];
  depreciation?: boolean;
  damageDeductible?: DamageDeductible;
  theftDeductible?: TheftDeductible;
  uwQuestions?: UwQuestions;
  offeredForFree?: boolean;

  constructor(props: TermsProps) {
    Object.assign(this, props);
  }

  resetOnCountryChange() {
    this.variant = undefined;
    this.damageDeductible = undefined;
  }

  upsell(variant: Variant) {
    this.variant = variant;
  }
}
